<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="940px"
    top="4vh"
    class="profit-task-dialog"
    :close-on-click-modal="false"
    @close="close"
  >
    <div v-loading="loading" class="dialog-body">
      <el-form :model="form" label-position="top" size="small" class="task-form">
        <div class="section-title"><span></span>基本信息</div>
        <div class="form-grid two">
          <el-form-item label="关联活动" :required="!isDetail" :error="fieldError('profitBonusActivityId')">
            <el-select
              v-model="form.profitBonusActivityId"
              :disabled="isDetail"
              filterable
              placeholder="请选择关联活动"
              @change="onActivityChange"
            >
              <el-option
                v-for="item in activityOptions"
                :key="item.id"
                :label="item.activityName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="任务时间" :required="!isDetail" :error="fieldError('timeRange')">
            <el-input v-if="isDetail" :value="detailTimeRangeText" disabled />
            <el-date-picker
              v-else
              v-model="form.timeRange"
              :picker-options="taskPickerOptions"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="任务名称" :required="!isDetail" :error="fieldError('taskName')">
            <el-input v-model.trim="form.taskName" :disabled="isDetail" maxlength="50" clearable placeholder="请输入任务名称" />
          </el-form-item>
          <el-form-item label="任务类型" :required="!isDetail" :error="fieldError('taskType')">
            <el-select v-model="form.taskType" :disabled="isDetail" placeholder="请选择任务类型" @change="onTaskTypeChange">
              <el-option v-for="item in taskTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="任务说明" :required="!isDetail" :error="fieldError('taskDesc')">
          <el-input
            v-model.trim="form.taskDesc"
            :disabled="isDetail"
            type="textarea"
            :rows="2"
            maxlength="50"
            show-word-limit
            placeholder="请输入任务说明"
          />
        </el-form-item>

        <template v-if="isInviteTask">
          <div class="section-title"><span></span>有效邀请规则</div>
          <div class="form-grid two">
            <el-form-item label="充值金额" :required="!isDetail" :error="fieldError('validInviteRechargeAmount')">
              <el-input
                v-model.trim="form.validInviteRechargeAmount"
                :disabled="isDetail"
                maxlength="15"
                placeholder="请输入充值金额"
                @input="onFormIntegerInput('validInviteRechargeAmount', $event, 15)"
              >
                <template slot="append">USDT</template>
              </el-input>
            </el-form-item>
            <el-form-item label="合约交易金额" :required="!isDetail" :error="fieldError('validInviteContractTradeAmount')">
              <el-input
                v-model.trim="form.validInviteContractTradeAmount"
                :disabled="isDetail"
                maxlength="15"
                placeholder="请输入合约交易金额"
                @input="onFormIntegerInput('validInviteContractTradeAmount', $event, 15)"
              >
                <template slot="append">USDT</template>
              </el-input>
            </el-form-item>
          </div>
        </template>

        <div class="tier-head">
          <div class="section-title tier-title"><span></span>阶梯奖励规则</div>
          <el-button
            v-if="!isDetail"
            type="primary"
            plain
            size="small"
            icon="el-icon-plus"
            :disabled="form.tiers.length >= 15"
            @click="addTier"
          >
            新增阶梯
          </el-button>
        </div>
        <el-table :data="form.tiers" border size="small" class="task-tier-table">
          <el-table-column label="阶梯" width="120" align="center">
            <template slot-scope="scope">阶梯{{ scope.row.tierNo }}</template>
          </el-table-column>
          <el-table-column :label="targetLabel" min-width="330" align="center">
            <template slot-scope="scope">
              <el-form-item class="tier-form-item" :error="tierFieldError(scope.$index, targetField)">
                <el-input
                  v-model.trim="scope.row[targetField]"
                  :disabled="isDetail"
                  :maxlength="isInviteTask ? 5 : 15"
                  size="mini"
                  placeholder="请输入"
                  @input="onTierIntegerInput(scope.row, targetField, $event, isInviteTask ? 5 : 15)"
                >
                  <template slot="append">{{ targetUnit }}</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="奖励加成比例" min-width="260" align="center">
            <template slot-scope="scope">
              <el-form-item class="tier-form-item" :error="tierFieldError(scope.$index, 'bonusRate')">
                <el-input
                  v-model.trim="scope.row.bonusRate"
                  :disabled="isDetail"
                  size="mini"
                  placeholder="0.00"
                  @input="onTierDecimalInput(scope.row, 'bonusRate', $event, 2)"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column v-if="!isDetail" label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="form.tiers.length > 1 && scope.$index === form.tiers.length - 1"
                type="text"
                size="small"
                class="danger-text"
                @click="removeTier(scope.$index)"
              >
                删除
              </el-button>
              <span v-else class="muted-text">-</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!isDetail" class="form-hint">阶梯从1开始，只能删除最后一条，至少保留一条</div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template v-if="isDetail">
        <el-button type="primary" size="small" @click="visible = false">确认</el-button>
      </template>
      <template v-else>
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button type="primary" size="small" :disabled="submitting" @click="submit">确定</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import api from '../api'

const TASK_TYPE_CONTRACT = 1
const TASK_TYPE_INVITE = 2

function defaultTaskForm() {
  return {
    id: null,
    profitBonusActivityId: '',
    taskName: '',
    taskType: TASK_TYPE_CONTRACT,
    taskDesc: '',
    timeRange: [],
    validInviteRechargeAmount: '',
    validInviteContractTradeAmount: '',
    tiers: [newTaskTier(1)],
  }
}

function newTaskTier(tierNo) {
  return {
    tierNo,
    validInviteCount: '',
    contractTradeAmount: '',
    bonusRate: '',
  }
}

export default {
  name: 'ProfitBonusTaskFormDialog',
  props: {
    value: Boolean,
    mode: {
      type: String,
      default: 'add',
    },
    taskId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      submitting: false,
      taskShowErrors: false,
      taskTierErrorIndexes: [],
      activityOptions: [],
      form: defaultTaskForm(),
      taskPickerOptions: {
        disabledDate: (time) => this.taskDateDisabled(time),
      },
      taskTypeOptions: [
        { label: '累计合约交易', value: TASK_TYPE_CONTRACT },
        { label: '邀请好友', value: TASK_TYPE_INVITE },
      ],
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isDetail() {
      return this.mode === 'detail'
    },
    dialogTitle() {
      if (this.mode === 'edit') return '修改任务'
      if (this.mode === 'detail') return '任务详情'
      return '新增任务'
    },
    selectedActivity() {
      return this.activityOptions.find((item) => Number(item.id) === Number(this.form.profitBonusActivityId))
    },
    isInviteTask() {
      return this.form.taskType === TASK_TYPE_INVITE
    },
    targetLabel() {
      return this.isInviteTask ? '有效邀请人数' : '累计合约交易量'
    },
    targetUnit() {
      return this.isInviteTask ? '人' : 'USDT'
    },
    targetField() {
      return this.isInviteTask ? 'validInviteCount' : 'contractTradeAmount'
    },
    formErrors() {
      return this.collectFormErrors()
    },
    formInvalidReason() {
      return this.formErrors.first || ''
    },
    formValid() {
      return !this.formInvalidReason
    },
    detailTimeRangeText() {
      const range = this.form.timeRange || []
      if (range.length !== 2) return ''
      return `${range[0]} 00:00:00 - ${range[1]} 23:59:59`
    },
  },
  watch: {
    value(open) {
      if (open) this.init()
    },
  },
  methods: {
    async init() {
      this.loading = true
      this.submitting = false
      this.resetTaskValidationState()
      this.form = defaultTaskForm()
      try {
        const optionsRes = await api.taskActivityOptions()
        this.activityOptions = (optionsRes && optionsRes.data) || []
        if (this.mode !== 'add' && this.taskId) {
          const detailRes = await api.taskDetail(this.taskId)
          this.fillForm((detailRes && detailRes.data) || {})
        }
      } finally {
        this.loading = false
      }
    },
    fillForm(data) {
      this.form = {
        id: data.id,
        profitBonusActivityId: data.profitBonusActivityId || '',
        taskName: data.taskName || '',
        taskType: data.taskType || TASK_TYPE_CONTRACT,
        taskDesc: data.taskDesc || '',
        timeRange: [this.beijingDateText(data.startTime), this.beijingDateText(data.endTime)].filter(Boolean),
        validInviteRechargeAmount: this.rawText(data.validInviteRechargeAmount),
        validInviteContractTradeAmount: this.rawText(data.validInviteContractTradeAmount),
        tiers: (data.tiers || []).map((item) => ({
          tierNo: item.tierNo,
          validInviteCount: this.rawText(item.validInviteCount),
          contractTradeAmount: this.rawText(item.contractTradeAmount),
          bonusRate: this.rawText(item.bonusRate),
        })),
      }
      if (!this.form.tiers.length) {
        this.form.tiers = [newTaskTier(1)]
      }
    },
    onActivityChange() {
      this.applyActivityTime()
    },
    onTaskTypeChange() {
      this.form.validInviteRechargeAmount = ''
      this.form.validInviteContractTradeAmount = ''
      this.form.tiers = [newTaskTier(1)]
      this.resetTaskValidationState()
    },
    applyActivityTime() {
      const activity = this.selectedActivity
      if (!activity) {
        this.form.timeRange = []
        return
      }
      const minStart = this.taskMinStartTime(activity)
      const maxEnd = Number(activity.endTime)
      if (!maxEnd || minStart > maxEnd) {
        this.form.timeRange = []
        this.$message.error('所选活动剩余时间不足，无法配置任务时间')
        return
      }
      this.form.timeRange = [this.beijingDateText(minStart), this.beijingDateText(maxEnd)]
    },
    addTier() {
      if (this.form.tiers.length >= 15) {
        this.$message.error('阶梯最多支持15条')
        return
      }
      const lastIndex = this.form.tiers.length - 1
      const lastError = this.firstTierErrorText(this.form.tiers[lastIndex], lastIndex)
      if (lastError) {
        this.taskTierErrorIndexes = [lastIndex]
        this.$message.error(lastError)
        return
      }
      this.form.tiers.push(newTaskTier(this.form.tiers.length + 1))
      this.taskTierErrorIndexes = []
    },
    removeTier(index) {
      if (this.form.tiers.length <= 1) {
        this.$message.error('至少保留一条阶梯')
        return
      }
      if (index !== this.form.tiers.length - 1) {
        this.$message.error('只能删除最后一条阶梯')
        return
      }
      this.form.tiers.pop()
    },
    submit() {
      this.taskShowErrors = true
      if (!this.formValid) {
        this.$message.error(this.formInvalidReason || '请完善任务配置')
        return
      }
      const taskTimeRange = this.taskTimePayload()
      const payload = {
        id: this.form.id,
        profitBonusActivityId: this.form.profitBonusActivityId,
        taskName: this.form.taskName,
        taskType: this.form.taskType,
        taskDesc: this.form.taskDesc,
        startTime: taskTimeRange[0],
        endTime: taskTimeRange[1],
        validInviteRechargeAmount: this.isInviteTask ? this.form.validInviteRechargeAmount : null,
        validInviteContractTradeAmount: this.isInviteTask ? this.form.validInviteContractTradeAmount : null,
        tiers: this.form.tiers.map((row, index) => ({
          tierNo: index + 1,
          validInviteCount: this.isInviteTask ? row.validInviteCount : null,
          contractTradeAmount: this.isInviteTask ? null : row.contractTradeAmount,
          bonusRate: row.bonusRate,
        })),
      }
      this.submitting = true
      const request = this.mode === 'edit' ? api.taskUpdate(payload) : api.taskAdd(payload)
      request.then(() => {
        this.$message.success(this.mode === 'edit' ? '修改成功' : '新增成功')
        this.visible = false
        this.$emit('success')
      }).finally(() => {
        this.submitting = false
      })
    },
    collectFormErrors() {
      const errors = { tiers: [], first: '' }
      const set = (field, message) => {
        if (!message) return
        errors[field] = message
        if (!errors.first) errors.first = message
      }
      if (!this.form.profitBonusActivityId) {
        set('profitBonusActivityId', '请选择关联活动')
      } else if (!this.selectedActivity) {
        set('profitBonusActivityId', '关联活动不存在')
      }
      const range = this.form.timeRange || []
      if (range.length !== 2) {
        set('timeRange', '请选择任务时间')
      } else if (!this.beijingStartOfDay(range[0]) || !this.beijingEndOfDay(range[1])) {
        set('timeRange', '任务时间格式不正确')
      } else if (this.selectedActivity) {
        const startTime = this.beijingStartOfDay(range[0])
        const endTime = this.beijingEndOfDay(range[1])
        const minStart = this.taskMinStartTime(this.selectedActivity)
        const maxEnd = Number(this.selectedActivity.endTime)
        if (minStart > maxEnd) {
          set('timeRange', '所选活动剩余时间不足，无法配置任务时间')
        } else if (startTime < minStart) {
          set('timeRange', `任务开始时间不能早于${this.formatTime(minStart)}`)
        } else if (endTime > maxEnd) {
          set('timeRange', '任务结束时间不能晚于活动结束时间')
        } else if (endTime <= startTime) {
          set('timeRange', '任务结束时间必须大于任务开始时间')
        }
      }
      const taskName = String(this.form.taskName || '').trim()
      if (!taskName) {
        set('taskName', '请填写任务名称')
      } else if (taskName.length > 50) {
        set('taskName', '任务名称最多50个字符')
      }
      if (!this.form.taskType) set('taskType', '请选择任务类型')
      const taskDesc = String(this.form.taskDesc || '').trim()
      if (!taskDesc) {
        set('taskDesc', '请填写任务说明')
      } else if (taskDesc.length > 50) {
        set('taskDesc', '任务说明最多50个字符')
      }
      if (this.isInviteTask) {
        set('validInviteRechargeAmount', this.nonNegativeIntegerError(this.form.validInviteRechargeAmount, 15, '充值金额'))
        set('validInviteContractTradeAmount', this.nonNegativeIntegerError(this.form.validInviteContractTradeAmount, 15, '合约交易金额'))
      }
      if (!this.form.tiers.length) {
        set('tiers', '请配置阶梯奖励规则')
      } else {
        let previousValue = null
        let previousRate = null
        this.form.tiers.forEach((row, index) => {
          const rowErrors = this.buildTierErrors(row, index, previousValue, previousRate)
          errors.tiers[index] = rowErrors
          const currentValue = Number(row[this.targetField])
          if (this.positiveInteger(row[this.targetField], this.isInviteTask ? 5 : 15)) {
            previousValue = currentValue
          }
          if (this.positivePercent(row.bonusRate)) {
            previousRate = Number(row.bonusRate)
          }
          const firstTier = this.firstErrorFrom(rowErrors)
          if (firstTier && !errors.first) errors.first = firstTier
        })
      }
      return errors
    },
    buildTierErrors(row, index, previousValue, previousRate) {
      const errors = {}
      const prefix = `第${index + 1}阶梯`
      const targetError = this.positiveIntegerError(row && row[this.targetField], this.isInviteTask ? 5 : 15, `${prefix}${this.targetLabel}`)
      if (targetError) {
        errors[this.targetField] = targetError
      } else if (previousValue !== null && Number(row[this.targetField]) <= previousValue) {
        errors[this.targetField] = `${prefix}${this.targetLabel}必须大于前一阶梯`
      }
      const rateError = this.positivePercentError(row && row.bonusRate, `${prefix}奖励加成比例`)
      if (rateError) errors.bonusRate = rateError
      if (!errors.bonusRate && previousRate !== null && Number(row.bonusRate) < previousRate) {
        errors.bonusRate = `${prefix}奖励加成比例不能小于前一阶梯`
      }
      return errors
    },
    firstTierErrorText(row, index) {
      const previousRow = this.form.tiers[index - 1]
      const previous = previousRow && this.positiveInteger(previousRow[this.targetField], this.isInviteTask ? 5 : 15)
        ? Number(previousRow[this.targetField])
        : null
      const previousRate = previousRow && this.positivePercent(previousRow.bonusRate)
        ? Number(previousRow.bonusRate)
        : null
      return this.firstErrorFrom(this.buildTierErrors(row, index, previous, previousRate))
    },
    firstErrorFrom(errors) {
      const fields = [this.targetField, 'bonusRate']
      const key = fields.find((field) => errors[field])
      return key ? errors[key] : ''
    },
    fieldError(field) {
      if (this.isDetail || !this.visible) return ''
      if (!this.taskShowErrors) return ''
      return this.formErrors[field] || ''
    },
    tierFieldError(index, field) {
      if (this.isDetail || !this.visible) return ''
      if (!this.taskShowErrors && !this.taskTierErrorIndexes.includes(index)) return ''
      const rowErrors = this.formErrors.tiers[index] || {}
      return rowErrors[field] || ''
    },
    resetTaskValidationState() {
      this.taskShowErrors = false
      this.taskTierErrorIndexes = []
    },
    taskTimePayload() {
      const range = this.form.timeRange || []
      return [this.beijingStartOfDay(range[0]), this.beijingEndOfDay(range[1])]
    },
    taskDateDisabled(time) {
      const activity = this.selectedActivity
      if (!activity) return this.localDateText(time) < this.beijingTomorrowDateText()
      const dateText = this.localDateText(time)
      const minDate = this.beijingDateText(this.taskMinStartTime(activity))
      const maxDate = this.beijingDateText(activity.endTime)
      return dateText < minDate || dateText > maxDate
    },
    taskMinStartTime(activity) {
      return Math.max(Number(activity.startTime || 0), this.beijingTomorrowStart())
    },
    beijingTomorrowStart() {
      const today = this.beijingDateText(Date.now())
      return this.beijingStartOfDay(today) + 24 * 60 * 60 * 1000
    },
    beijingTomorrowDateText() {
      return this.beijingDateText(this.beijingTomorrowStart())
    },
    beijingStartOfDay(value) {
      return this.beijingBoundary(value, 0, 0, 0)
    },
    beijingEndOfDay(value) {
      return this.beijingBoundary(value, 23, 59, 59)
    },
    beijingBoundary(value, hour, minute, second) {
      if (!value) return null
      const parts = String(value).split('-').map((item) => Number(item))
      if (parts.length !== 3 || parts.some((item) => !Number.isInteger(item))) return null
      const [year, month, day] = parts
      return Date.UTC(year, month - 1, day, hour, minute, second, 0) - 8 * 60 * 60 * 1000
    },
    beijingDateText(value) {
      if (value === null || value === undefined || value === '') return ''
      const date = new Date(Number(value) + 8 * 60 * 60 * 1000)
      if (Number.isNaN(date.getTime())) return ''
      return `${date.getUTCFullYear()}-${this.padDate(date.getUTCMonth() + 1)}-${this.padDate(date.getUTCDate())}`
    },
    localDateText(date) {
      return `${date.getFullYear()}-${this.padDate(date.getMonth() + 1)}-${this.padDate(date.getDate())}`
    },
    padDate(value) {
      return String(value).padStart(2, '0')
    },
    onFormIntegerInput(field, value, maxDigits) {
      this.form[field] = this.sanitizeIntegerInput(value, maxDigits)
    },
    onTierIntegerInput(row, field, value, maxDigits) {
      row[field] = this.sanitizeIntegerInput(value, maxDigits)
    },
    onTierDecimalInput(row, field, value, maxDecimalPlaces) {
      row[field] = this.sanitizeDecimalInput(value, maxDecimalPlaces)
    },
    sanitizeIntegerInput(value, maxDigits) {
      return String(value == null ? '' : value).replace(/\D/g, '').slice(0, maxDigits)
    },
    sanitizeDecimalInput(value, maxDecimalPlaces) {
      const text = String(value == null ? '' : value).replace(/[^\d.]/g, '')
      const dotIndex = text.indexOf('.')
      if (dotIndex < 0) return text
      const integerPart = text.slice(0, dotIndex) || '0'
      const decimalPart = text.slice(dotIndex + 1).replace(/\./g, '').slice(0, maxDecimalPlaces)
      return `${integerPart}.${decimalPart}`
    },
    nonEmpty(value) {
      return value !== null && value !== undefined && String(value).trim() !== ''
    },
    positiveIntegerError(value, maxDigits, fieldName) {
      if (!this.nonEmpty(value)) return `${fieldName}不能为空`
      return this.positiveInteger(value, maxDigits) ? '' : `${fieldName}仅支持1-${maxDigits}位正整数`
    },
    nonNegativeIntegerError(value, maxDigits, fieldName) {
      if (!this.nonEmpty(value)) return `${fieldName}不能为空`
      return new RegExp(`^(0|[1-9]\\d{0,${maxDigits - 1}})$`).test(String(value))
        ? ''
        : `${fieldName}仅支持0或1-${maxDigits}位正整数`
    },
    positiveInteger(value, maxDigits) {
      if (!this.nonEmpty(value)) return false
      return new RegExp(`^[1-9]\\d{0,${maxDigits - 1}}$`).test(String(value))
    },
    positivePercentError(value, fieldName) {
      if (!this.nonEmpty(value)) return `${fieldName}不能为空`
      return this.positivePercent(value)
        ? ''
        : `${fieldName}必须大于0且最多支持两位小数`
    },
    positivePercent(value) {
      if (!this.nonEmpty(value)) return false
      return /^(0\.(0[1-9]|[1-9]\d?)|[1-9]\d*(\.\d{1,2})?)$/.test(String(value))
    },
    rawText(value) {
      if (value === null || value === undefined) return ''
      return String(value)
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const d = new Date(Number(timestamp) + 8 * 60 * 60 * 1000)
      if (Number.isNaN(d.getTime())) return '-'
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`
    },
    close() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="less" scoped>
.profit-task-dialog {
  /deep/ .el-dialog__header {
    padding: 18px 24px 8px;
  }

  /deep/ .el-dialog__body {
    padding: 14px 24px 8px;
  }

  /deep/ .el-dialog__footer {
    padding: 12px 24px 16px;
    border-top: 1px solid #edf1f7;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;

    /deep/ .el-button + .el-button {
      margin-left: 0;
    }
  }

  .dialog-body {
    max-height: 72vh;
    padding-right: 6px;
    overflow-y: auto;
  }

  .section-title {
    display: flex;
    align-items: center;
    margin: 2px 0 10px;
    color: #0f2454;
    font-size: 14px;
    font-weight: 600;

    span {
      display: inline-block;
      width: 4px;
      height: 18px;
      margin-right: 8px;
      border-radius: 2px;
      background: #1f6bff;
    }
  }

  .form-grid {
    display: grid;
    gap: 10px 28px;

    &.two {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .el-select,
  .el-date-editor {
    width: 100%;
  }

  /deep/ .el-form-item {
    margin-bottom: 12px;
  }

  /deep/ .el-form-item__label {
    padding-bottom: 4px;
    color: #253858;
    font-weight: 500;
    line-height: 20px;
  }

  /deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    color: #f56c6c;
  }

  /deep/ .el-input.is-disabled .el-input__inner,
  /deep/ .el-textarea.is-disabled .el-textarea__inner,
  /deep/ .el-select .el-input.is-disabled .el-input__inner {
    color: #31456f;
    background-color: #f7f9fc;
    border-color: #d6deee;
    cursor: not-allowed;
  }

  /deep/ .el-input-group__append {
    min-width: 36px;
    padding: 0 8px;
    color: #536683;
    background: #f4f7fb;
    border-color: #d6deee;
  }

  .tier-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
    margin-bottom: 12px;
  }

  .tier-title {
    margin-bottom: 0;
  }

  .task-tier-table {
    width: 100%;

    /deep/ .cell {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 32px;
      padding-right: 8px;
      padding-left: 8px;
      overflow: visible;
    }
  }

  .tier-form-item {
    width: 100%;
    margin-bottom: 0;

    /deep/ .el-form-item__content {
      line-height: 28px;
    }

    /deep/ .el-form-item__error {
      position: static;
      width: 100%;
      padding-top: 2px;
      line-height: 13px;
      white-space: normal;
      text-align: left;
    }
  }

  .form-hint {
    margin-top: 10px;
    color: #8492c4;
    font-size: 12px;
  }

  .danger-text {
    color: #f56c6c;
  }

  .muted-text {
    color: #a6b0c2;
  }
}
</style>
